








import Vue from "vue";

export default Vue.extend({
  name: "Parallax",
  props: {
    text1: String,
    text2: String,
    background: String,
  },
});
